import React, { useMemo } from 'react';
import './ClienteColumna.scss';
import ClienteRutaCard from '../ClienteRutaCard/ClienteRutaCard';

const ClienteColumna = ({ cliente, rutas, onRutaClick }) => {
    // Obtener el nombre y ID del cliente
    const nombreCliente = Array.isArray(cliente) ? (cliente[0]?.trim() || '') : (cliente || '');
    const clienteId = Array.isArray(cliente) ? (cliente[1] || '') : '';

    // Agrupar rutas por turno
    const rutasPorTurno = useMemo(() => {
        const grupos = {};

        rutas.forEach(ruta => {
            const turno = ruta.turno || 'SIN TURNO';
            if (!grupos[turno]) {
                grupos[turno] = [];
            }
            grupos[turno].push(ruta);
        });

        return grupos;
    }, [rutas]);

    // Ordenar turnos (SA, EA, E1, S1, etc.)
    const turnosOrdenados = useMemo(() => {
        const turnos = Object.keys(rutasPorTurno);
        return turnos.sort((a, b) => {
            // Orden personalizado: SA, EA, E1, E2, ..., S1, S2, ...
            const orden = { 'SA': 1, 'EA': 2 };
            const valorA = orden[a] || (a.startsWith('E') ? 10 + parseInt(a.substring(1) || '0') : 100 + parseInt(a.substring(1) || '0'));
            const valorB = orden[b] || (b.startsWith('E') ? 10 + parseInt(b.substring(1) || '0') : 100 + parseInt(b.substring(1) || '0'));
            return valorA - valorB;
        });
    }, [rutasPorTurno]);

    // Calcular totales
    const rutasCompletadas = rutas.filter(r => r.completada).length;
    const todasCompletadas = rutas.every(ruta => ruta.completada);
    // Detectar zona de las rutas (todas deberían tener la misma zona)
    const zona = rutas.length > 0 && rutas[0].zona ? rutas[0].zona.toLowerCase() : '';

    // Mapeo de colores por zona
    const coloresPorZona = {
        'a': 'zona-azul',
        'b': 'zona-verde',
        'c': 'zona-naranja'
    };
    const claseZona = coloresPorZona[zona] || '';
    return (
        <div className="cliente-columna">
            {/* Header de la columna con info del cliente */}
            <div className={`columna-header ${claseZona}`} >
                <div className="header-titulo">
                    <h3 className="cliente-nombre">{nombreCliente}</h3>
                    <div className='container-flex'>
                        {clienteId && <span className="cliente-id">ID: {clienteId}</span>}
                        {zona && <span className={`label-zona ${claseZona}`}>ZONA {zona.toUpperCase()}</span>}
                    </div>

                </div>
                <div className="header-progreso">
                    <div className={`indicador ${todasCompletadas ? 'completo' : 'pendiente'}`}>
                        <span className="progreso-texto">{rutasCompletadas}/{rutas.length}</span>
                    </div>
                </div>
            </div>

            {/* Cards por turno - cada turno tiene su propia card completa */}
            <div className="columna-body">
                {turnosOrdenados.map(turno => (
                    <ClienteRutaCard
                        key={turno}
                        cliente={cliente}
                        rutas={rutasPorTurno[turno]}
                        turno={turno}
                        onRutaClick={onRutaClick}
                    />
                ))}
            </div>
        </div>
    );
};

export default ClienteColumna;
